const magicInfoData = [
  {
    title: "Complete Display Solutions with Magicinfo Software",

    image: "./images/magic_info1.webp",
    reverse: false
  },
];

export default magicInfoData;